import { IconType } from 'react-icons';
import {
  FaJava, FaDocker, FaGitAlt, FaJenkins, FaAngular,
  FaGithub, FaLinkedin, FaEnvelope, FaCloud
} from 'react-icons/fa';
import {
  SiTypescript, SiPostgresql, SiApachespark, SiKubernetes,
  SiGrafana, SiSplunk, SiSpringboot, SiScala, SiApachehive,
  SiSnowflake, SiJira, SiConfluence, SiBitbucket, SiApachemaven,
  SiRedhatopenshift, SiArgo
} from 'react-icons/si';

// Loghi dei clienti

// Loghi delle certificazioni
import cambridgeB1Logo from '../assets/certifications/b1.png';
import psm1Logo from '../assets/certifications/psm1.png';
import scrumLogo from '../assets/certifications/scrum.png';
import secureCodeLogo from '../assets/certifications/securecode.png';
import ecdlLogo from '../assets/certifications/ecdl.png';

/* ================================
   DATI PERSONALI
   ================================ */

export const personalInfo = {
  name: 'Luca Dell\'Aera',
  title: 'Senior Software Engineer Analyst',
  subtitle: 'Backend development, Big Data, DevOps e CI/CD.',
  bio: `Sono un ingegnere informatico con esperienza consolidata nello sviluppo software e nella consulenza IT, specializzato in soluzioni enterprise e sistemi distribuiti.
    Ho avuto l'opportunità di lavorare su progetti complessi in diversi settori (trasporti, energia, media, pubblica amministrazione), collaborando con importanti clienti nazionali e internazionali.
    Mi contraddistinguono una forte passione per la tecnologia, capacità di problem solving, attitudine al lavoro di squadra e competenze trasversali sia tecniche che metodologiche (Scrum Master certificato).`,
  location: 'Italia',
  email: 'dellaeraluca@gmail.com',
  resumeUrl: '#',
  avatarUrl: '',
};

/* ================================
   FORMAZIONE
   ================================ */

export interface Education {
  id: string;
  title: string;
  institution: string;
  period: string;
  description?: string;
}

export const education: Education[] = [
  {
    id: 'edu-1',
    title: 'Laurea in Ingegneria Informatica',
    institution: 'Università del Salento',
    period: '',
    description: '',
  },
  {
    id: 'edu-2',
    title: 'Academy Java e Stage',
    institution: '',
    period: '2019',
    description: '',
  },
];

/* ================================
   LINK SOCIAL
   ================================ */

export interface SocialLink {
  name: string;
  url: string;
  icon: IconType;
}

export const socialLinks: SocialLink[] = [
  { name: 'GitHub', url: 'https://github.com/dellaeraluca', icon: FaGithub },
  { name: 'LinkedIn', url: 'https://www.linkedin.com/in/luca-dell-aera-967830b3/', icon: FaLinkedin },
  { name: 'Email', url: 'mailto:dellaeraluca@gmail.com', icon: FaEnvelope },
];

/* ================================
   SKILLS / TECNOLOGIE
   ================================ */

export interface Skill {
  name: string;
  icon: IconType;
  color: string;
  category: 'frontend' | 'backend' | 'devops' | 'data' | 'agile';
}

export const skills: Skill[] = [
  // Backend & Linguaggi
  { name: 'Java', icon: FaJava, color: '#ED8B00', category: 'backend' },
  { name: 'Scala', icon: SiScala, color: '#DC322F', category: 'backend' },
  { name: 'Spring Framework', icon: SiSpringboot, color: '#6DB33F', category: 'backend' },
  { name: 'Apache Spark', icon: SiApachespark, color: '#E25A1C', category: 'backend' },

  // Frontend
  { name: 'Angular', icon: FaAngular, color: '#DD0031', category: 'frontend' },
  { name: 'TypeScript', icon: SiTypescript, color: '#3178C6', category: 'frontend' },

  // Database & Big Data
  { name: 'PostgreSQL', icon: SiPostgresql, color: '#4169E1', category: 'data' },
  { name: 'Snowflake SQL', icon: SiSnowflake, color: '#29B5E8', category: 'data' },
  { name: 'Hive SQL', icon: SiApachehive, color: '#FDEE21', category: 'data' },

  // DevOps & CI/CD
  { name: 'Docker', icon: FaDocker, color: '#2496ED', category: 'devops' },
  { name: 'Kubernetes', icon: SiKubernetes, color: '#326CE5', category: 'devops' },
  { name: 'OpenShift', icon: SiRedhatopenshift, color: '#EE0000', category: 'devops' },
  { name: 'Azure', icon: FaCloud, color: '#0078D4', category: 'devops' },
  { name: 'Jenkins', icon: FaJenkins, color: '#D24939', category: 'devops' },
  { name: 'ArgoCD', icon: SiArgo, color: '#EF7B4D', category: 'devops' },
  { name: 'Git', icon: FaGitAlt, color: '#F05032', category: 'devops' },

  // Monitoring & Logging
  { name: 'Grafana', icon: SiGrafana, color: '#F46800', category: 'devops' },
  { name: 'Splunk', icon: SiSplunk, color: '#000000', category: 'devops' },

  // Agile & Tools
  { name: 'Jira', icon: SiJira, color: '#0052CC', category: 'agile' },
  { name: 'Confluence', icon: SiConfluence, color: '#172B4D', category: 'agile' },
  { name: 'Bitbucket', icon: SiBitbucket, color: '#0052CC', category: 'agile' },
  { name: 'Maven', icon: SiApachemaven, color: '#C71A36', category: 'agile' },
];

/* ================================
   CERTIFICAZIONI
   ================================ */

export interface Certification {
  id: string;
  name: string;
  issuer: string;
  year?: string;
  logo?: string;  // Logo opzionale della certificazione
}

export const certifications: Certification[] = [
  { 
    id: 'cert-1', 
    name: 'English Certification B1', 
    issuer: 'Cambridge ESOL',
    logo: cambridgeB1Logo
  },
  { 
    id: 'cert-2', 
    name: 'PSM I (Professional Scrum Master I)', 
    issuer: 'Scrum.org',
    logo: psm1Logo
  },
  { 
    id: 'cert-3', 
    name: 'Scrum Fundamentals Certified', 
    issuer: 'SCRUMStudy',
    logo: scrumLogo
  },
  { 
    id: 'cert-4', 
    name: 'Secure Coding (OWASP Standard)', 
    issuer: 'Secure Code Warrior',
    logo: secureCodeLogo
  },
  { 
    id: 'cert-5', 
    name: 'ECDL Certification', 
    issuer: 'AICA',
    logo: ecdlLogo
  },
];

/* ================================
   CLIENTI E PROGETTI SEGUITI
   ================================ */

export interface Client {
  id: string;
  name: string;
  sector: string;
  description: string;
  icon?: IconType; // Icona opzionale per il cliente
  logo?: string;   // URL del logo opzionale
}

export const clients: Client[] = [];

/* ================================
   PROGETTI
   ================================ */

export interface Project {
  id: string;
  title: string;
  category: 'professionale' | 'personale';
  description: string;
  longDescription: string;
  image: string;
  tags: string[];
  githubUrl?: string;
  liveUrl?: string;
  featured: boolean;
}

export const projects: Project[] = [
  {
    id: 'portfolio-site',
    title: 'Portfolio Website',
    category: 'personale',
    description: 'Portfolio personale moderno costruito con React e TypeScript, dockerizzato per Raspberry Pi.',
    longDescription: 'Portfolio personale responsive con design dark mode, animazioni fluide, Docker-ready e ottimizzato per il deployment su Raspberry Pi con Nginx.',
    image: '',
    tags: ['React', 'TypeScript', 'Docker', 'Nginx'],
    githubUrl: 'https://github.com/dellaeraluca/web-portfolio',
    featured: true,
  },
];

/* ================================
   ESPERIENZE LAVORATIVE
   ================================ */

export interface Experience {
  id: string;
  role: string;
  company: string;
  companyUrl?: string;
  period: string;
  description: string;
  highlights: string[];
  technologies: string[];
}

export const experiences: Experience[] = [];

/* ================================
   NAVIGAZIONE
   ================================ */

export interface NavItem {
  label: string;
  href: string;
}

export const navItems: NavItem[] = [
  { label: 'Home', href: '#home' },
  { label: 'Chi Sono', href: '#about' },
  { label: 'Skills', href: '#skills' },
  { label: 'Certificazioni', href: '#certifications' },
  { label: 'Clienti', href: '#clients' },
  { label: 'Esperienza', href: '#experience' },
  { label: 'Contatti', href: '#contact' },
];
